import React, { useMemo } from "react";
import Carousel from "react-material-ui-carousel";
import { Box } from "@mui/material";
import image1 from "../../assets/Login/newlogin1.jpg";
import image2 from "../../assets/Login/newlogin2.jpg";
import image3 from "../../assets/Login/newlogin3.jpg";
import image4 from "../../assets/Login/newlogin4.jpg";
import image5 from "../../assets/Login/newlogin5.jpg";
import image6 from "../../assets/Login/newlogin6.jpg";

const Slide = ({ image }) => (
  <Box
    sx={{
      width: "100%",
      height: "100%",
      overflow: "hidden",
    }}
  >
    <img
      src={image}
      alt="Login visual"
      loading="lazy"
      srcSet={`${image} 1x, ${image.replace(".webp", "@2x.webp")} 2x`}
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
        willChange: "transform, opacity",
      }}
    />
  </Box>
);

const LoginSlider = () => {
  const items = useMemo(
    () => [image1, image2, image3, image4, image5, image6],
    []
  );

  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        position: "relative",
      }}
    >
      <Carousel
        animation="slide"
        duration={500}
        interval={2500}
        navButtonsAlwaysInvisible
        indicators
        swipe={false}
        autoPlay
        sx={{
          width: "100%",
          height: "100%",
          "& .carousel-slider": {
            overflow: "visible !important",
          },
        }}
        indicatorIconButtonProps={{
          style: {
            padding: "5px",
            color: "#fff",
            margin: "0 4px",
            width: "4px",
            height: "4px",
            borderRadius: "50%",
          },
        }}
        activeIndicatorIconButtonProps={{
          style: {
            width: "36px",
            height: "4px",
            borderRadius: "6px",
            backgroundColor: "#fff",
          },
        }}
        indicatorContainerProps={{
          style: {
            position: "absolute",
            bottom: "10px",
            zIndex: 2,
            width: "100%",
          },
        }}
      >
        {items.map((image, i) => (
          <Slide key={i} image={image} />
        ))}
      </Carousel>
    </Box>
  );
};

export default LoginSlider;
